import { useSelector, useDispatch } from "react-redux";
import { useEffect } from "react";
import {
  Container,
  Grid,
  Box,
  Typography
} from "@mui/material";

import Input from "@/components/ph/Input";
import Radio from "@/components/ph/Radio";
import Select from "@/components/ph/Select";

import FormSection from "../../utils/FormSection";

import { getFiscalAdressData } from "../contractorSlice";

import { useContractorValidation } from "../hooks/useContractorValidation";

const ContractorTaxAdress= () => {
    const dispatch = useDispatch();
    const formValues = useSelector((state) => state.contractor.formValues);
    const coloniasOptionsFiscal = useSelector((state) => state.contractor.coloniasOptionsFiscal);

    const fiscalCalleField = useContractorValidation("fiscalCalle", { required: true });
    const fiscalNumExtField = useContractorValidation("fiscalNumeroExterior", { required: true });


    const fiscalCodigoPostalField = useContractorValidation("fiscalCodigoPostal", { 
        required: true,
        validate: (value) => {
            const regex = /^\d{5}$/;
            if (!regex.test(value)) return "El código postal debe tener 5 dígitos";
            return null;
        },
        transformValue: (v) => v.replace(/\D/g, "").slice(0, 5),
        onKeyDown: (e) => {
            const allowedKeys = [
            'Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight', 
            'Home', 'End', 'Enter'
            ];
            
            if (allowedKeys.includes(e.key)) return;
            
            if (!/\d/.test(e.key)) {
            e.preventDefault();
            }
            
            if (e.target.value.length >= 5 && !allowedKeys.includes(e.key)) {
            e.preventDefault();
            }
        },
    });
    
    useEffect(() => {
        if (!fiscalCodigoPostalField.isInvalid) {
            dispatch(getFiscalAdressData({ zipCode: formValues.fiscalCodigoPostal }));
        }
    }, [formValues.fiscalCodigoPostal, fiscalCodigoPostalField.isInvalid, dispatch]);

    const fiscalEstadoField = useContractorValidation("fiscalEstadoRepublica", { required: true });
    const fiscalMunicipioField = useContractorValidation("fiscalAlcaldiaMunicipio", { required: true });
    const fiscalColoniaField = useContractorValidation("fiscalColonia", { required: true });
    const fiscalNumIntField = useContractorValidation("fiscalNumeroInterior", { required: false });

    return (
        <Container maxWidth="md" disableGutters={{ xs: true, md: false }}>
            <FormSection>
                <Grid container spacing={2} size={{ xs: 12, md: 12 }}>
                    <Grid size={{ xs: 12, md: 12 }}>
                        <Box
                        sx={{
                            minHeight: "3.5rem",
                            display: "flex",
                            alignItems: "flex-end",
                        }}
                        >
                        <Typography
                            variant="body1"
                            sx={{
                            color: "text.secondary",
                            mt: 1,
                            mb: 1,
                            fontSize: "1rem",
                            fontWeight: "500",
                            }}
                        >
                            DOMICILIO FISCAL
                        </Typography>
                        </Box>
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>
                        <Box
                            sx={{
                                minHeight: "3.5rem",
                                display: "flex",
                                alignItems: "flex-end",
                            }}
                            >
                        <Input
                            errorMessage={fiscalCodigoPostalField.getErrorMessage()}
                            label="Código Postal"
                            name="fiscalCodigoPostal"
                            value={fiscalCodigoPostalField.value}
                            onChange={fiscalCodigoPostalField.onChange}
                            onBlur={fiscalCodigoPostalField.onBlur}
                            isInvalid={fiscalCodigoPostalField.isInvalid}
                            required
                            type="text"
                        />
                        </Box>
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>
                        <Box
                            sx={{
                                minHeight: "3.5rem",
                                display: "flex",
                                alignItems: "flex-end",
                            }}
                            >
                        <Select
                            type="labeled"
                            label="Estado"
                            name="fiscalEstadoRepublica"
                            value={fiscalEstadoField.value}
                            onChange={fiscalEstadoField.onChange}
                            onBlur={fiscalEstadoField.onBlur}
                            options={formValues.fiscalEstadoRepublica ? 
                                [{ value: formValues.fiscalEstadoRepublica, label: formValues.fiscalEstadoRepublica }] : []}
                            isInvalid={fiscalEstadoField.isInvalid}
                            errorMessage={fiscalEstadoField.getErrorMessage()}
                            required
                        />
                        </Box>
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>
                        <Box
                            sx={{
                                minHeight: "3.5rem",
                                display: "flex",
                                alignItems: "flex-end",
                            }}
                            >
                        <Select
                            type="labeled"
                            label="Municipio/Delegación"
                            name="fiscalAlcaldiaMunicipio"
                            value={fiscalMunicipioField.value}
                            onChange={fiscalMunicipioField.onChange}
                            onBlur={fiscalMunicipioField.onBlur}
                            options={fiscalMunicipioField.value ? [{ value: fiscalMunicipioField.value, label: fiscalMunicipioField.value }] : []}
                            isInvalid={fiscalMunicipioField.isInvalid}
                            errorMessage={fiscalMunicipioField.getErrorMessage()}
                            required
                        />
                        </Box>
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>
                        <Box
                            sx={{
                                minHeight: "3.5rem",
                                display: "flex",
                                alignItems: "flex-end",
                            }}
                            >
                        <Select
                            type="labeled"
                            label="Colonia o Fraccionamiento"
                            name="fiscalColonia"
                            value={fiscalColoniaField.value}
                            onChange={fiscalColoniaField.onChange}
                            onBlur={fiscalColoniaField.onBlur}
                            options={coloniasOptionsFiscal || []}
                            isInvalid={fiscalColoniaField.isInvalid}
                            errorMessage={fiscalColoniaField.getErrorMessage()}
                            required
                            disabled={formValues.mismaDireccionFiscal}
                        />
                        </Box>
                    </Grid>
                    <Grid size={{ xs: 12 }}>
                        <Box
                            sx={{
                                minHeight: "3.5rem",
                                display: "flex",
                                alignItems: "flex-end",
                            }}
                            >
                        <Input
                            label="Calle"
                            name="fiscalCalle"
                            value={fiscalCalleField.value}
                            onChange={fiscalCalleField.onChange}
                            onBlur={fiscalCalleField.onBlur}
                            errorMessage={fiscalCalleField.getErrorMessage()}
                            isInvalid={fiscalCalleField.isInvalid}
                            required
                            type="text"
                            disabled={formValues.mismaDireccionFiscal}
                        />
                        </Box>
                    </Grid>
                    <Grid size={{ xs: 6, md: 6 }} className="cp-input">
                        <Box
                            sx={{
                                minHeight: "3.5rem",
                                display: "flex",
                                alignItems: "flex-end",
                            }}
                            >
                        <Input
                            label="N° Ext"
                            name="fiscalNumeroExterior"
                            value={fiscalNumExtField.value}
                            onChange={fiscalNumExtField.onChange}
                            onBlur={fiscalNumExtField.onBlur}
                            errorMessage={fiscalNumExtField.getErrorMessage()}
                            isInvalid={fiscalNumExtField.isInvalid}
                            required
                            type="text"
                        />
                        </Box>
                    </Grid>
                    <Grid size={{ xs: 6, md: 6 }} className="cp-input">
                        <Box
                            sx={{
                                minHeight: "3.5rem",
                                display: "flex",
                                alignItems: "flex-end",
                            }}
                            >
                        <Input
                            label="N° Int"
                            name="fiscalNumeroInterior"
                            value={fiscalNumIntField.value}
                            onChange={fiscalNumIntField.onChange}
                            onBlur={fiscalNumIntField.onBlur}
                            errorMessage={fiscalNumIntField.getErrorMessage()}
                            isInvalid={fiscalNumIntField.isInvalid}
                            type="text"
                            disabled={formValues.mismaDireccionFiscal}
                        />
                        </Box>
                    </Grid>
                </Grid>
            </FormSection>
        </Container>
    );
};

export default ContractorTaxAdress;
